import type {
	LockLootsheetInput,
	LockLootsheetResult,
	UnlockLootsheetInput,
	UnlockLootsheetResult
} from 'api-types';

import {LootsheetLockDuck, GuildDuck, BannerDuck, Rpc} from '@ducks';

import api from '../../helpers/api';

import type {LootsheetLock} from '@models/lootsheetLock';

/** Lock a lootsheet */
export function lockLootsheet(data: {
	wowInstanceId: LootsheetLock['wowInstanceId'];
	difficulty: LootsheetLock['difficulty'];
}): Thunk<void> {
	return (dispatchEvent, getState) => {
		const state = getState();
		const guildId = GuildDuck.getActiveGuildId(state.guilds);
		if (!guildId) return Promise.resolve();

		dispatchEvent<LootsheetLockDuck.Actions['LOCK']>({
			type: LootsheetLockDuck.LOCK,
			payload: {}
		});

		return api
			.call<LockLootsheetInput, LockLootsheetResult>(Rpc.LOOTSHEET_LOCK, {
				guildId,

				wowInstanceId: data.wowInstanceId,
				difficulty: data.difficulty
			})
			.then(
				() => {
					dispatchEvent(BannerDuck.addSuccessBanner('Lootsheet has been locked'));
				},

				(message) => {
					dispatchEvent(BannerDuck.addErrorBanner(message.error));
				}
			);
	};
}

/** Unlock a lootsheet */
export function unlockLootsheet(data: {
	wowInstanceId: LootsheetLock['wowInstanceId'];
	difficulty: LootsheetLock['difficulty'];
}): Thunk<void> {
	return (dispatchEvent, getState) => {
		const state = getState();
		const guildId = GuildDuck.getActiveGuildId(state.guilds);
		if (!guildId) return Promise.resolve();

		dispatchEvent<LootsheetLockDuck.Actions['UNLOCK']>({
			type: LootsheetLockDuck.UNLOCK,
			payload: {}
		});

		return api
			.call<UnlockLootsheetInput, UnlockLootsheetResult>(Rpc.LOOTSHEET_UNLOCK, {
				guildId,

				wowInstanceId: data.wowInstanceId,
				difficulty: data.difficulty
			})
			.then(
				() => {
					dispatchEvent(BannerDuck.addSuccessBanner('Lootsheet has been unlocked'));
				},

				(message) => {
					dispatchEvent(BannerDuck.addErrorBanner(message.error));
				}
			);
	};
}
